import { loadAndAddImage } from '../image_helpers';

const clusterImageId = color => {
  return `map-cluster-${color}`;
};

const clusterImageSrc = color => {
  return `https://cdn-assets.alltrails.com/assets/icons/maps/clusters/map-cluster-${color}@2x.png`;
};

const addClusterImageToMap = (map, color) => {
  const imageId = clusterImageId(color);
  const imageSrc = clusterImageSrc(color);
  return loadAndAddImage(map, imageId, imageSrc, {
    pixelRatio: 2
  });
};

const createClusterLayer = (id, sourceId, color, opacity) => {
  return {
    id,
    type: 'symbol',
    source: sourceId,
    filter: ['has', 'point_count'],
    layout: {
      'text-allow-overlap': true,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-image': ['image', clusterImageId(color)],
      'icon-size': 1,
      'text-field': '{point_count_abbreviated}',
      'text-font': ['Proxima Nova Bold'],
      'text-size': 12
    },
    paint: {
      'text-color': 'white',
      'icon-opacity': opacity || 1
    }
  };
};

export { addClusterImageToMap, createClusterLayer };
